// extracted by mini-css-extract-plugin
export default {"main":"main_main__NJbcS","mainBody":"main_mainBody__4Lhoi"};